import PropTypes from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';
import styles from './styles/SellerApplicationConfirmation.scss';
import { MOBILE } from 'dibs-buyer-layout/exports/deviceTypeEnums.ts';

export function SellerApplicationConfirmation({ deviceType }) {
    return (
        <div className={styles.wrapper}>
            <h1 className={styles.heading}>
                <FormattedMessage
                    id="DealerApplicationConfirmation.title"
                    defaultMessage="Thank you for your application"
                />
            </h1>
            <p className={styles.body}>
                <FormattedMessage
                    id="DealerApplicationConfirmation.body"
                    defaultMessage="Please note, that we do have a waitlist to join our seller community.  We will only contact you if your application is approved or if we need more details."
                />
            </p>
            <div className={styles.image}>
                {deviceType !== MOBILE && (
                    <img
                        src="https://a.1stdibscdn.com/dist/adhoc/app-buyer-misc/confirmation_page_items.jpg"
                        alt="Confirmation Page Items"
                    />
                )}
            </div>
        </div>
    );
}

SellerApplicationConfirmation.propTypes = {
    deviceType: PropTypes.string.isRequired,
};
